export default "__VITE_ASSET__eWMM4HmY__"